// src/routes.js

import React from "react";
import { Navigate } from "react-router-dom";
import Home from "../pages/Home";
import Dashboard from "../pages/Dashboard";

const routes = [
  {
    path: "/conflux/cspace",
    element: <Home />,
    title: "Stake - Core Space - Conflux Staking | Goldshell Stake"
  },
  {
    path: "/conflux/cspace/dashboard",
    element: <Dashboard />,
    title: "Core Space - Conflux Staking Dashboard | Goldshell Stake"
  },
  {
    path: "*",
    element: <Navigate to="/conflux/cspace" />,
    title: "Redirect - Goldshell Stake"
  },
];

export default routes;
